import CartMessagesView from 'cart-messages.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IPerformance, IZone } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state';
import { removeItemFromCart, removeSelectedZone } from '../../redux-state/actions/package-listing.actions';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { filterMap } from '../../helpers/map-helpers';
import { IPerformanceErrorMessage } from '../../../package-listing/classes/package-listing';


interface StateToProps {
    text: IPackageListingAppText;
    groupName: string;
    maxReached: boolean;
    cartPerformanceCount: number;
    processPackageErrorMessage: string;
    packageMin: number;
    shouldRender: boolean;
}

interface ICartMessageExternalProps {
    performanceGroupId: number;
}

export type CartMessagesProps = StateToProps & ICartMessageExternalProps;

export class FiltersBase extends React.Component<CartMessagesProps, any> {
    constructor(props: CartMessagesProps) {
        super(props);
    }

    render() {
        return <CartMessagesView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: ICartMessageExternalProps): StateToProps {

    const requiresPerformanceGroups = state.packageListingSettings.isFixed ? false
        : (state.packageListing.packageDetail.performanceGroupDetails.length > 1
            && state.packageListing.packageDetail.performanceGroupDetails.filter(pg => pg.minimumPerformances > 0
                || pg.maximumPerformances != state.packageListing.packageDetail.maximumPerformances).length > 0);

    var processError: Array<IPerformanceErrorMessage> = [];
    if (state.packageListing.errorMessages != undefined)
        processError = state.packageListing.errorMessages.filter(err => err.performanceId === 0);

    if (requiresPerformanceGroups) {

        if (ownProps.performanceGroupId == null)
            return {} as any;
        else {
            var matchedPerfGroup = state.packageListing.packageDetail.performanceGroupDetails.filter(group => group.id === ownProps.performanceGroupId)[0];
            var groupPerfIds = [];
            if (matchedPerfGroup) {
                groupPerfIds = matchedPerfGroup.tessPerformances.map(perf => perf.performanceId);
            }

            const cartPerfs = state.packageListing.cartItems.filter((perf) => groupPerfIds.indexOf(perf.cartItemId) >= 0);

            const groupMax = matchedPerfGroup.maximumPerformances == null ? state.packageListing.packageDetail.maximumPerformances
                : matchedPerfGroup.maximumPerformances;
            return {
                text: state.packageListingText,
                processPackageErrorMessage: processError.length > 0 ? processError[0].errorMessage : "",
                cartPerformanceCount: state.packageListingSettings.useUnseatedReservation ?
                    cartPerfs.filter(cartItem => cartItem.selectedZoneId > 0).length
                    : cartPerfs.length,
                maxReached: cartPerfs.length >= groupMax,
                packageMin: matchedPerfGroup.minimumPerformances,
                groupName: matchedPerfGroup.description,
                shouldRender: true
            }
        }

    } else {
        return {
            text: state.packageListingText,
            processPackageErrorMessage: processError.length > 0 ? processError[0].errorMessage : "",
            cartPerformanceCount: state.packageListingSettings.useUnseatedReservation ?
                state.packageListing.cartItems.filter(cartItem => cartItem.selectedZoneId > 0).length
                : state.packageListing.cartItems.length,
            maxReached: state.packageListingSettings.isFixed ? false : (state.packageListing.cartItems.length >= state.packageListing.packageDetail.maximumPerformances),
            packageMin: state.packageListingSettings.isFixed ? 0 : (state.packageListing.packageDetail.minimumPerformances),
            groupName: "",
            shouldRender: true
        }
    }
}


export default connect<StateToProps>(mapStateToProps)(FiltersBase);